export const recordQualityMessages = {
  'zh-CN': {
    title: '识别质量',
    historyAccessible: '最近 60 次画面处理：绿色表示经验识别正常，黄色表示识别有问题，灰色表示尚未采集',
    recognized: '识别正常', issue: '需要关注', notYet: '未采集',
    window: '游戏画面', ocr: '文字识别', location: '识别位置', processing: '平均处理耗时',
    noReading: '暂无数据', milliseconds: '{count} ms',
    copy: '复制诊断', copied: '诊断信息已复制', copyFailed: '复制失败，请重试',
  },
  en: {
    title: 'Recognition quality',
    historyAccessible: 'Last 60 processed frames: green means EXP was readable, yellow means a recognition issue, gray means no frame yet',
    recognized: 'Recognized', issue: 'Needs attention', notYet: 'No frame yet',
    window: 'Game frame', ocr: 'Text recognition', location: 'Reading area', processing: 'Average processing time',
    noReading: 'No data yet', milliseconds: '{count} ms',
    copy: 'Copy diagnostics', copied: 'Diagnostics copied', copyFailed: 'Copy failed. Retry',
  },
  'zh-TW': {
    title: '辨識品質',
    historyAccessible: '最近 60 次畫面處理：綠色表示經驗辨識正常，黃色表示辨識有問題，灰色表示尚未擷取',
    recognized: '辨識正常', issue: '需要留意', notYet: '未擷取',
    window: '遊戲畫面', ocr: '文字辨識', location: '辨識位置', processing: '平均處理耗時',
    noReading: '尚無資料', milliseconds: '{count} ms',
    copy: '複製診斷', copied: '診斷資訊已複製', copyFailed: '複製失敗，請重試',
  },
  ja: {
    title: '認識の品質',
    historyAccessible: '直近60回の画面処理。緑は経験値を読み取れた画面、黄は認識に問題がある画面、灰は未処理です',
    recognized: '認識成功', issue: '要確認', notYet: '未処理',
    window: 'ゲーム画面', ocr: '文字認識', location: '認識位置', processing: '平均処理時間',
    noReading: 'データなし', milliseconds: '{count} ms',
    copy: '診断情報をコピー', copied: '診断情報をコピーしました', copyFailed: 'コピーできませんでした。再試行してください',
  },
  ko: {
    title: '인식 품질',
    historyAccessible: '최근 처리한 화면 60개: 초록색은 경험치 인식 성공, 노란색은 인식 문제, 회색은 아직 처리되지 않음을 뜻합니다',
    recognized: '인식 정상', issue: '확인 필요', notYet: '미처리',
    window: '게임 화면', ocr: '문자 인식', location: '인식 위치', processing: '평균 처리 시간',
    noReading: '데이터 없음', milliseconds: '{count} ms',
    copy: '진단 정보 복사', copied: '진단 정보를 복사했습니다', copyFailed: '복사하지 못했습니다. 다시 시도하세요',
  },
} as const
